import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionDepartamentosEditarComponent {
  constructor(FanProyectoConfiguracionDepartamentosDepartamentoService) {
    this.FanProyectoConfiguracionDepartamentosDepartamentoService = FanProyectoConfiguracionDepartamentosDepartamentoService
    this.procesando = false
    this.idProyecto = undefined
    this.idDepartamento = undefined
    this.onClose = undefined
  }

  $onInit() {
    this.promise = this.FanProyectoConfiguracionDepartamentosDepartamentoService.get(this.idProyecto, this.idDepartamento)
      .then((response) => (this.data = response.data))
  }

  aceptar(pristine, valid) {
    if (!valid || this.procesando) {
      return
    }

    if (pristine) {
      this.onClose()

      return
    }

    this.procesando = true

    let data = {
      descripcion: this.data.descripcion,
      nivel_1_cuenta: this.data.nivel_1_cuenta,
      nivel_2_cuenta: this.data.nivel_2_cuenta,
      nivel_3_cuenta: this.data.nivel_3_cuenta,
      nivel_4_cuenta: this.data.nivel_4_cuenta,
    }

    this.FanProyectoConfiguracionDepartamentosDepartamentoService.put(this.idProyecto, this.idDepartamento, data)
      .then((response) => {
        this.data = response.data

        this.onClose({$event: {data: this.data}})
      })
      .finally(() => (this.procesando = false))
  }

  cerrar(pristine) {
    if (pristine === false) {
      return
    }

    this.onClose()
  }
}

module.component('fanProyectoConfigDepartamentosEditar', {
  controller: FanProyectoConfiguracionDepartamentosEditarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idDepartamento: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/departamentos/editar/component.js